<template>

  <div id="entry"  class="well" style="padding: 0 1em;">

    <b-tabs content-class="mt-3" justified>

          <div class="dataTables_scrollBody" style="position: relative; overflow: auto; max-height: 400px; width: 100%; border-bottom: 1px solid #111; border-top: 1px solid #111;">
            <table class="ncut-table-menu-striped ncut-table-menu" bgcolor="#FFFFFF">
              <thead class="ncut-thead-menu">
                  <tr>
                    <th style="min-width: 2em;">序號</th>
                  <th style="min-width: 38em;">課程名稱</th>
                  <th style="min-width: 5em;">上課日期</th>
                  </tr>
              </thead>
              <tbody class="ncut-tbody-menu">
                <tr v-for="(item, index) in filteredDocs" :key="item.cid" :index="item.cid" :name="item.cid"
                  v-bind:style="{'background': (selectedRowIndex==index? headerColor: '')}"
                  @click="selectedRowIndex=index">
                   <td style="text-align: right;">{{(currentPage-1)*pageSize+index+1}}</td>
                  <td style="text-align: left;">
                      <!-- <a v-bind:href="'/CourseDetailView/'+item.cid"> {{item.courseClass}}</a> -->
<router-link :to="{path: '/CourseDetail/' ,query: {cid: item.cid }}"> {{item.courseClass}} </router-link>
                    </td>
                  <td style="text-align: left;">{{item.sdate}}</td>

                </tr>
              </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            v-if="total>pageSize" />
          </div>

      </b-tabs>

  </div>
</template>

<script>
import * as tools from '../tool'
export default {
  name: 'entry',
  data () {
    return {
      total: 0,
      isIE: false,
      inputData: null,
      selectedRowIndex: 0,
      currentPage: 1,
      pageSize: 10,
      queryInfo: {
        sysId: 0

      }

    }
  },
  computed: {

    	filteredDocs: function () {
      let data = []
      if (this.inputData != null) {
        data = this.inputData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }
      return data
    },
    headerColor () {
      return '#f7e8aa'
    }
  },
  created () {
    console.log('======created EntryView =====')
    this.isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1

    const vm = this
    this.mode = (this.id == 0 ? 1 : 2)
    this.$http.get('./WebApi/ociaRep/GetociaRepList/')
      .then((response) => {
        if (!tools.isNull(response)) {
          vm.inputData = response.data
          console.log(vm.inputData)
        }
      })
      .catch(function (error) {
        tools.showAlert(vm.inputData, 'danger', '網路連線失敗' + error)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
